<template>
  <div class="links">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Review and feedback Links</span>
      </heading-wrap>

      <spinner v-if="loading" />

      <search-box v-model="search" name="links..." @input="triggerSearch" />

      <table-links-quick-preview
          v-if="listType === 'quick-preview'"
          :showModalHandler="showModalHandler"
          :showPager="true" />
      <table-links-review-comments
          v-if="listType === 'review-and-comments'"
          :showModalHandler="showModalHandler"
          :showPager="true"
          :cloneReviewHandler="cloneReviewHandler"
      />
    </div>

    <portal to="globalModal">
      <modal-link-confirm
          :show="showModal.deleteLink"
          :confirmId="modalId"
          :linkType="modalFieldType"
          :type="modalField"
          @close="toggleModal('deleteLink')"/>
      <modal-edit-link
          :show="showModal.editLink"
          :type="modalType"
          :confirmId="modalId"
          :field="modalField"
          :linkType="modalFieldType"
          :allowEditPassword="listType === 'review-and-comments'"
          @close="toggleModal('editLink')"/>
      <modal-refresh-link
          :show="showModal.refreshLink"
          :type="modalType"
          :confirmId="modalId"
          :linkType="modalFieldType"
          @close="toggleModal('refreshLink')"/>
      <modal-create-preview-link
          v-if="showModal.createPreviewLink"
          :creativeData="creativeData"
          :selectedUnitsIds="selectedUnitsIds"
          :show="showModal.createPreviewLink"
          :type="modalType"
          :confirmId="modalId"
          :isClone="true"
          :currentLinkName="modalField"
          @actionChange="cloneReviewAction"
          @close="toggleModal('createPreviewLink')" />
      <modal-preview-link
          v-if="showModal.previewLink"
          :show="showModal.previewLink"
          :type="modalType"
          :confirmId="modalId"
          :responseData="modalData"
          @close="closePreviewLinkModal" />
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ShareUrlBox from '@/components/ShareUrlBox/share-url-box'
import Spinner from '@/components/SpinnerIcon/spinner'

import SearchBox from '@/components/SearchBox/searchbox'
import Modal from '@/components/Modal/modal'
import ModalLinkConfirm from '@/components/Modal/links/modal-link-confirm'

import ModalEditLink from '@/components/Modal/links/modal-edit-link'
import ModalRefreshLink from '@/components/Modal/links/modal-refresh-link'
import {modalMixin} from '@/mixins/modalMixin'

import {linkMixin, LINKS_TABLE_TYPES} from '@/mixins/linkMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import TableLinksReviewComments from '@/components/LinksReviewComments/table-links-review-comments'

import TableLinksQuickPreview from '@/components/LinksReviewComments/table-links-quick-preview'
import ModalCreatePreviewLink from '@/components/Modal/creatives/modal-create-preview-link'
import ModalPreviewLink from '@/components/Modal/creatives/modal-preview-link'

import {creativeMixin} from '@/mixins/creativeMixin'

export default {
  name: 'Links',
  mixins: [modalMixin, linkMixin, notificationMixin, creativeMixin],
  components: {
    HeadingWrap,
    ShareUrlBox,
    Modal,
    Spinner,
    SearchBox,
    ModalLinkConfirm,
    ModalEditLink,
    ModalRefreshLink,
    TableLinksReviewComments,
    TableLinksQuickPreview,
    ModalCreatePreviewLink,
    ModalPreviewLink
  },
  props: {
    tableData: Array
  },
  data: () => ({
    search: '',
    searchTimeOutId: null,
    selectedUnitsIds: [],
    creativeData: {}
  }),
  mounted () {
  },
  computed: {
    listType () {
      return this.$route.params.type
    }
  },
  methods: {
    showModalHandler (event) {
      this.onLaunchModal(event)
    },
    cloneReviewAction (data) {
      this.startLoading()
      this.updateBulkCreative(data.currentTarget.dataset).then(response => {
        this.selectedUnitsIds = []
        this.creativeData = {}
        if (response.preview_url) {
          this.modalData = response
          this.showModal['previewLink'] = true
          this.finishLoading()
        }
      })
    },
    cloneReviewHandler (evt) {
      this.startLoading()
      const dataset = evt.currentTarget.dataset
      this.validateReviewClone(evt.currentTarget.dataset.hashid).then(({data}) => {
        this.finishLoading()
        this.selectedUnitsIds = []
        if (data.units_fail.length > 0) {
          let unitsFailed = ''
          data.units_fail.forEach((item, i) => {
            unitsFailed += ` \n  -> ${item.locale}: ${item.master} | ${item.width}x${item.height} `
          })
          const notification = this.addNotification('danger', `Please make sure that all the units related with this review link are in state rendered: ${unitsFailed}`)
          setTimeout(() => {
            this.closeLastNotification(notification.id)
          }, 15000) // Wait 15 second to remove the notification
          return false
        }
        data.units_success.forEach((item) => {
          this.selectedUnitsIds.push(item.id)
        })
        data.creative.units = data.units_success
        this.creativeData['data'] = {creative: data.creative, units: data.units_success}
        this.onLaunchModal({currentTarget: {dataset}})
      })
    },
    closePreviewLinkModal () {
      this.toggleModal('previewLink')
      this.startLoading()
      this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS).then(() => {
        this.finishLoading()
      })
    },
    triggerSearch (value) {
      if (this.searchTimeOutId) {
        clearTimeout(this.searchTimeOutId)
      }

      this.searchTimeOutId = setTimeout(() => {
        const terms = value.trim()
        this.setLinksSearchTerms(terms === '' ? null : terms)
        this.startLoading()
        this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS).then(() => {
          this.finishLoading()
        })
        clearTimeout(this.searchTimeOutId)
      }, 800)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/review-links-type.vue